import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "@/components/AppShell";
import VendorOverview from "@/pages/vendor/Overview";
import VendorBranding from "@/pages/vendor/Branding";
import VendorRFQ from "@/pages/vendor/RFQ";
import PortalTeam from "@/components/PortalTeam";
import VendorPurchaseOrders from "@/pages/vendor/PurchaseOrders";
import CustomersManage from "@/pages/shared/CustomersManage";

// Reused pages (renamed for the Vendor portal)
import FinishedProducts from "@/pages/inventory/FinishedProducts";
import Stock from "@/pages/inventory/Stock";
import GRN from "@/pages/procurement/GRN";
import Finance from "@/pages/finance/Finance";
import Pricing from "@/pages/distributor/Pricing";
import Logistics from "@/pages/distributor/Logistics";
import BI from "@/pages/distributor/BI";
import DistributorDispatch from "@/pages/distributor/DistributorDispatch";
import DistributorCollections from "@/pages/distributor/DistributorCollections";
import AuditLog from "@/pages/settings/AuditLog";
import MfaSettings from "@/pages/settings/Mfa";

export default function VendorDashboard() {
  return (
    <AppShell variant="vendor">
      <Routes>
        <Route path="/" element={<VendorOverview />} />
        <Route path="/branding" element={<VendorBranding />} />
        <Route path="/catalog" element={<Navigate to="/vendor" replace />} />
        <Route path="/products" element={<FinishedProducts />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/rfq" element={<VendorRFQ />} />
        <Route path="/manufacturing" element={<Navigate to="/vendor" replace />} />
        <Route path="/staff" element={<PortalTeam portal="VENDOR" title="Team & staff" />} />
        <Route path="/purchase-orders" element={<VendorPurchaseOrders />} />
        <Route path="/customers" element={<CustomersManage title="Customers" subtitle="Buyers and channel partners this vendor sells to — builders, architects, designers, contractors and end-users." />} />
        <Route path="/grn" element={<GRN />} />
        <Route path="/shipments" element={<DistributorDispatch title="Shipments" subtitle="Every buyer order — pending, completed, and shipped/delivered." />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/logistics" element={<Logistics />} />
        <Route path="/payments" element={<Finance />} />
        <Route path="/receipts" element={<DistributorCollections title="Receipts" subtitle="Every shipment and its buyer-payment status — one shipment per row." />} />
        <Route path="/bi" element={<BI />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/settings/mfa" element={<MfaSettings />} />
        <Route path="*" element={<Navigate to="/vendor" replace />} />
      </Routes>
    </AppShell>
  );
}
